export default __webpack_public_path__ + "static/media/growth.87973db3.svg";